import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_player_header = _resolveComponent("player-header")!
  const _component_active_player_area = _resolveComponent("active-player-area")!
  const _component_inactive_player_area = _resolveComponent("inactive-player-area")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["player-area", [
      `player-area-${_ctx.player.id}`,
      `player-area-${_ctx.position}`,
      { active: _ctx.isActive },
      { 'must-discard': _ctx.resourcesToDiscard > 0 },
    ]])
  }, [
    _createVNode(_component_player_header, { player: _ctx.player }, null, 8, ["player"]),
    (_ctx.isActive)
      ? (_openBlock(), _createBlock(_component_active_player_area, {
          key: 0,
          player: _ctx.player
        }, null, 8, ["player"]))
      : (_openBlock(), _createBlock(_component_inactive_player_area, {
          key: 1,
          player: _ctx.player
        }, null, 8, ["player"]))
  ], 2))
}